import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { TherapistEventService } from '../../../../../services/api/TherapistEventService';
import { TherapistEventDetailsModel } from '../../../../../models/api/TherapistEventDetails';
import { TherapistEventModel } from '../../../../../models/api/TherapistEventModel';
import { DatePipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { A11yModule } from "@angular/cdk/a11y";

@Component({
  selector: 'app-event-therapist-detail',
  standalone: true,
  imports: [DatePipe, MatDialogTitle, MatDialogContent, MatButtonModule, MatDialogClose, MatSlideToggleModule, A11yModule],
  templateUrl: './event-therapist-detail.component.html',
  styleUrl: './event-therapist-detail.component.scss'
})
export class EventTherapistDetailComponent implements OnInit {

public therapistID: number = 0;
public eventID: number = 0;
public isReloading: boolean = false;
//public therapistEventDetail: TherapistEventDetailsModel[] = [];
public therapistEventDetail: TherapistEventDetailsModel[] = [];

constructor(
  private therapistEventService: TherapistEventService,
      @Inject(MAT_DIALOG_DATA) public data?: { therapistID: number, eventID: number }
){
    if (data?.therapistID) {
      this.therapistID = data?.therapistID;
    }
    if (data?.eventID){
      this.eventID = data?.eventID;
    }
}

ngOnInit(): void {
  
  if (this.therapistID > 0){
    this.getEventTherapists();
  }


}


getEventTherapists(){

this.therapistEventService.getByTherapistAndEvent(this.therapistID, this.eventID).subscribe({
  next: (data) => {
    this.therapistEventDetail = data;
    this.isReloading = false;
  },
  error: (err) => {
  }
})
}

onToggle(event: any, therapistEventID: number, state: boolean){



    this.therapistEventService.getTherapistEvent(therapistEventID).subscribe({
      next: (data) => {
        let therapistEventData = data;
        
        if (state){
          therapistEventData.active = false;
        } else {
          therapistEventData.active = true;
        }

        this.therapistEventService.updateTherapistEvent(therapistEventID, therapistEventData).subscribe({
          next: (data) => {
            this.isReloading = true;
            this.getEventTherapists();
          },
        error: (err) => {

        }
        })


      },
      error: (err) => {

      }
    });
  }

}
